import comp from "./StudentEndSidebar";

export default comp;
